import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AvatarModule } from 'primeng/avatar';
import { getInitials } from '@shared/pipes/initials.pipe';

@Component({
    selector: 'app-card-person',
    imports: [CommonModule, AvatarModule],
    templateUrl: './card-person.component.html',
    styleUrl: './card-person.component.scss',
    standalone: true
})
export class CardPersonComponent {
  name = input<string>();
  avatar = input<string>();
  estado = input();
  age = input();
  country = input();
  duration = input();
  imageError = false;

  getInitials(name?: string | null): string {
    return getInitials(name);
  }
}
